// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-dual-box-canvas .rdl-control-container {
  height: 100%;
}

.rdl-control-container {
  width: 160px;
}

.cv-offcanvas-container {
  width: 95vw !important;
  border-left: 1px solid #d3d3d3 !important;
}

.cv-footer {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  border-top: 1px solid #d3d3d3;
}

.cv-footer-clear,
.cv-footer-cancel,
.cv-footer-apply {
  border-radius: 0;
  background-color: #fff;
  color: #0a56ae;
  border: 1px solid #0a56ae;
  font-weight: 400;
}

.cv-footer-save {
  border-radius: 0;
  background-color: #0a56ae;
  color: #fff;
  border: 1px solid #0a56ae;
  font-weight: 400;
}

.cv-footer-cancel:hover,
.cv-footer-clear:hover,
.cv-footer-save:hover,
.cv-footer-apply:hover {
  background-color: #e0edff;
  border: 1px solid #495cff;
  transition: 0.3s;
}

.cv-form {
  overflow-x: hidden;
}

.main-content-oc {
  padding: 8px;
  display: flex;
  flex-direction: row;
  gap: 10px;
}

@media (min-width: 1024px) {
  .main-content-oc {
    height: 77vh;
  }

  .rdl-control-container {
    width: 160px;
  }
}
@media (min-width: 1366px) {
  .main-content-oc {
    height: 85vh;
  }

  .rdl-control-container {
    width: 215px;
  }
}
@media (min-width: 1920px) {
  .main-content-oc {
    height: 85vh;
  }

  .rdl-control-container {
    width: 280px !important;
  }
}`, "",{"version":3,"sources":["webpack://./../report/src/components/UniversalReport/TimelineCustomView/TimelineCustomView.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,sBAAA;EACA,yCAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,aAAA;EACA,6BAAA;AACF;;AAEA;;;EAGE,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AAEA;;;;EAIE,yBAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE;IACE,YAAA;EACF;;EAEA;IACE,YAAA;EACF;AACF;AAEA;EACE;IACE,YAAA;EAAF;;EAGA;IACE,YAAA;EAAF;AACF;AAGA;EACE;IACE,YAAA;EADF;;EASA;IACE,uBAAA;EANF;AACF","sourcesContent":[".custom-dual-box-canvas .rdl-control-container {\n  height: 100%;\n}\n\n.rdl-control-container {\n  width: 160px;\n}\n\n.cv-offcanvas-container {\n  width: 95vw !important;\n  border-left: 1px solid #d3d3d3 !important;\n}\n\n.cv-footer {\n  display: flex;\n  justify-content: space-between;\n  padding: 15px;\n  border-top: 1px solid #d3d3d3;\n}\n\n.cv-footer-clear,\n.cv-footer-cancel,\n.cv-footer-apply {\n  border-radius: 0;\n  background-color: #fff;\n  color: #0a56ae;\n  border: 1px solid #0a56ae;\n  font-weight: 400;\n}\n\n.cv-footer-save {\n  border-radius: 0;\n  background-color: #0a56ae;\n  color: #fff;\n  border: 1px solid #0a56ae;\n  font-weight: 400;\n}\n\n.cv-footer-cancel:hover,\n.cv-footer-clear:hover,\n.cv-footer-save:hover,\n.cv-footer-apply:hover {\n  background-color: #e0edff;\n  border: 1px solid #495cff;\n  transition: 0.3s;\n}\n\n.cv-form {\n  overflow-x: hidden;\n}\n\n.main-content-oc {\n  padding: 8px;\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n}\n\n@media (min-width: 1024px) {\n  .main-content-oc {\n    height: 77vh;\n  }\n\n  .rdl-control-container {\n    width: 160px;\n  }\n}\n\n@media (min-width: 1366px) {\n  .main-content-oc {\n    height: 85vh;\n  }\n\n  .rdl-control-container {\n    width: 215px;\n  }\n}\n\n@media (min-width: 1920px) {\n  .main-content-oc {\n    height: 85vh;\n  }\n\n  // .cv-offcanvas-container {\n  //   width: 80vw !important;\n  //   border-left: 1px solid #d3d3d3;\n  // }\n\n  .rdl-control-container {\n    width: 280px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
